(function ($) {
  "use strict";

  //////
  $("button#sign-in-modal, .c-modal__close, .c-modal__close-background").on("click", function () {
    $("html").toggleClass("modal-sign-in--is-active");
  });

  // ✅ Select from Shopify's built-in radio inputs
  $('input[type="radio"]').on("change", function () {
    const variantName = $(this).val();
    const allVariantImages = $('.thumbnail-list .thumbnail-list__item:not([data-title="all"])').hide();
    const selectedVariantImages = $('.thumbnail-list .thumbnail-list__item[data-title="' + variantName + '"]');

    allVariantImages.hide();
    if (selectedVariantImages.length) {
      selectedVariantImages.show();
    } else {
      allVariantImages.show();
    }
  });

  // On load: trigger the same image logic for the checked radio input
  $(document).ready(function () {
    const selectedRadio = $('input[type="radio"]:checked');
    if (selectedRadio.length) {
      const variantName = selectedRadio.val();
      const allVariantImages = $('.thumbnail-list .thumbnail-list__item:not([data-title="all"])').hide();
      const selectedVariantImages = $('.thumbnail-list .thumbnail-list__item[data-title="' + variantName + '"]');

      allVariantImages.hide();
      if (selectedVariantImages.length) {
        selectedVariantImages.show();
      } else {
        allVariantImages.show();
      }
    }
  });

  ///////

  // add class to html if is shop or products
  $(document).ready(function () {
    var url = window.location.pathname;
    if (url.includes("/collections/") || url.includes("/products/")) {
      $("html").addClass("is-shop");
    }
  });

  // toggle search and burger menu html "is active" class
  $(document).ready(function () {
    $(".modal__toggle, .modal__close").click(function () {
      console.log(".modal__toggle, .modal__close clicked");
      $("html").toggleClass("overflow-fixed");
    });
  });

  // pagination
  $(document).ready(function () {
    $("#vbcwex7iss").parent().addClass("page-1-start");
    $("#wxr44qkdmvd").parent().addClass("page-2-start");
    $("#az8y3798sg4").parent().addClass("page-3-start");

    console.log("#vbcwex7iss");
  });

  // detect if external link
  $(document).ready(function () {
    $('.list-menu__item[href^="https://"]').attr("target", "_blank");
  });

  // toggle top menu sub menu
  $(document).ready(function () {
    $(".top-global-menu__item > .has-sub-menu").click(function () {
      var subMenu = $(this).siblings(".top-global-menu__list");
      subMenu.toggleClass("is-active");
    });
  });

  // mega menu view all style button
  $(document).ready(function () {
    $(".list-menu > li").each(function () {
      // Find the closest <span> inside the current <li>
      var $text = $(this).find("span").first().text().trim();

      // Add the text as a class to the <li>, replacing spaces with hyphens
      if ($text) {
        $(this).addClass($text.replace(/\s+/g, "-").toLowerCase());
      }
    });

    $(".list-menu > li.your-products").each(function () {
      // Find all the .mega-menu__link elements inside the current <li>
      $(this)
        .find(".mega-menu__list li")
        .each(function () {
          var $text = $(this).find(".mega-menu__link").text().trim();

          // Add the text as a class to the current <li>, replacing spaces with hyphens
          if ($text) {
            $(this).addClass($text.replace(/\s+/g, "-").toLowerCase());
          }
        });
    });

    // only show menu item relating to the data-attr of the body
    var dataCollection = $("body").attr("data-collection");
    $(".mega-menu__list li." + dataCollection).addClass("is-active");
  });
})(jQuery);
